import { render } from "./Clock.vue?vue&type=template&id=544483ff"
import script from "./Clock.vue?vue&type=script&lang=ts"
export * from "./Clock.vue?vue&type=script&lang=ts"
script.render = render

export default script